import { getConfigOrThrow } from 'gossamer-front-end';
import { DownloadButton } from '../ancillary/DownloadButton';
import { EventTileIcon } from './EventTileIcon';
import classes from './EventTileIcon.module.css';

interface AttendeeCertificateDownloadButtonProps {
  disabled?: boolean;
  ticketBookingId: number;
}

export const AttendeeCertificateDownloadButton = (props: AttendeeCertificateDownloadButtonProps) => (
  <DownloadButton
    disabled={props.disabled}
    title={props.disabled ? 'Not available' : 'Download certificate'}
    className={[classes.EventTileIcon, props.disabled ? 'inactive' : 'active'].join(' ')}
    url={[getConfigOrThrow('gossamer-be-origin'), 'gossamer/main/certificate-attendee', props.ticketBookingId].join(
      '/',
    )}
  >
    <img src="/assets/icons/trophy.svg" />
  </DownloadButton>
);
